import { AxiosRequestConfig } from 'axios';
import axios from './axios';
import { BoardTile, CreateTilePayload } from './boardTile.interface';

const createTile = (data: CreateTilePayload): Promise<BoardTile> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'post',
        url: '/board-tiles',
        data,
      };
      const resp = await axios(config);
      resolve(resp.data.data);
    } catch (error) {
      reject(error);
    }
  });
};

const getTilesByCard = (cardId: string): Promise<BoardTile[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: `/board-tiles/${cardId}`,
      };
      const resp = await axios(config);
      resolve(resp.data.data);
    } catch (error) {
      reject(error);
    }
  });
};

const getTileCount = (cardId: string): Promise<{ count: number }> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'get',
        url: `/board-tiles/${cardId}/count`,
      };
      const resp = await axios(config);
      resolve(resp.data.data);
    } catch (error) {
      reject(error);
    }
  });
};

const updateTile = (tileId: string, data: Partial<BoardTile>): Promise<BoardTile> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'put',
        url: `/board-tiles/${tileId}`,
        data,
      };
      const resp = await axios(config);
      resolve(resp.data.data);
    } catch (error) {
      reject(error);
    }
  });
};

const deleteTile = (tileId: string): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'delete',
        url: `/board-tiles/${tileId}`,
      };
      await axios(config);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

const reorderTiles = (cardId: string, tileIds: string[]): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const config: AxiosRequestConfig = {
        method: 'put',
        url: `/board-tiles/${cardId}/reorder`,
        data: { tileIds },
      };
      await axios(config);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const boardTileService = {
  createTile,
  getTilesByCard,
  getTileCount,
  updateTile,
  deleteTile,
  reorderTiles,
};
